export const checkSubscriptionError = (errors?: Error[]) => !!(errors?.length ?? 0);
